<template>
    <div>
        <!-- unCryptos 侧边导航栏 -->
        <un-cryptos-navigation-mobile v-if="$route.meta.app == 'unCryptos'" :drawer="navigationDrawer" @watchNavigationDrawer="watchNavigationDrawer"></un-cryptos-navigation-mobile>
        <!-- unNFTs 侧边导航栏 -->
        <un-nfts-navigation-mobile v-else-if="$route.meta.app == 'unNFTs'" :drawer="navigationDrawer" @watchNavigationDrawer="watchNavigationDrawer"></un-nfts-navigation-mobile>
        <!-- Untrading 侧边导航栏 -->
        <untrading-navigation-mobile v-else :drawer="navigationDrawer" @watchNavigationDrawer="watchNavigationDrawer"></untrading-navigation-mobile>
        <v-app-bar fixed elevation="0" color="f2f">
            <template v-slot:prepend>
                <div class="ml-2 pointer text-icon" @click="navigationDrawer = !navigationDrawer">
                    <svg width="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.35719 3H14.6428C15.7266 2.99999 16.6007 2.99998 17.3086 3.05782C18.0375 3.11737 18.6777 3.24318 19.27 3.54497C20.2108 4.02433 20.9757 4.78924 21.455 5.73005C21.7568 6.32234 21.8826 6.96253 21.9422 7.69138C22 8.39925 22 9.27339 22 10.3572V13.6428C22 14.7266 22 15.6008 21.9422 16.3086C21.8826 17.0375 21.7568 17.6777 21.455 18.27C20.9757 19.2108 20.2108 19.9757 19.27 20.455C18.6777 20.7568 18.0375 20.8826 17.3086 20.9422C16.6008 21 15.7266 21 14.6428 21H9.35717C8.27339 21 7.39925 21 6.69138 20.9422C5.96253 20.8826 5.32234 20.7568 4.73005 20.455C3.78924 19.9757 3.02433 19.2108 2.54497 18.27C2.24318 17.6777 2.11737 17.0375 2.05782 16.3086C1.99998 15.6007 1.99999 14.7266 2 13.6428V10.3572C1.99999 9.27341 1.99998 8.39926 2.05782 7.69138C2.11737 6.96253 2.24318 6.32234 2.54497 5.73005C3.02433 4.78924 3.78924 4.02433 4.73005 3.54497C5.32234 3.24318 5.96253 3.11737 6.69138 3.05782C7.39926 2.99998 8.27341 2.99999 9.35719 3ZM6.85424 5.05118C6.24907 5.10062 5.90138 5.19279 5.63803 5.32698C5.07354 5.6146 4.6146 6.07354 4.32698 6.63803C4.19279 6.90138 4.10062 7.24907 4.05118 7.85424C4.00078 8.47108 4 9.26339 4 10.4V13.6C4 14.7366 4.00078 15.5289 4.05118 16.1458C4.10062 16.7509 4.19279 17.0986 4.32698 17.362C4.6146 17.9265 5.07354 18.3854 5.63803 18.673C5.90138 18.8072 6.24907 18.8994 6.85424 18.9488C7.17922 18.9754 7.55292 18.9882 8 18.9943V5.0057C7.55292 5.01184 7.17922 5.02462 6.85424 5.05118ZM10 5V19H14.6C15.7366 19 16.5289 18.9992 17.1458 18.9488C17.7509 18.8994 18.0986 18.8072 18.362 18.673C18.9265 18.3854 19.3854 17.9265 19.673 17.362C19.8072 17.0986 19.8994 16.7509 19.9488 16.1458C19.9992 15.5289 20 14.7366 20 13.6V10.4C20 9.26339 19.9992 8.47108 19.9488 7.85424C19.8994 7.24907 19.8072 6.90138 19.673 6.63803C19.3854 6.07354 18.9265 5.6146 18.362 5.32698C18.0986 5.19279 17.7509 5.10062 17.1458 5.05118C16.5289 5.00078 15.7366 5 14.6 5H10Z" fill="currentColor"></path></svg>
                </div>
                <Logo v-if="$route.meta.app" class="ml-6" :type="$route.meta.app" :app="$route.meta.app" responsive="pc" :color="darkTheme == 1 ? 'dark' : 'light'" ></Logo>
            </template>
            <template v-slot:append>
                <v-row no-gutters justify="space-between" align="center">
                    <span @click="avatarMenu = !avatarMenu">
                        <Avatar class="mr-6" :menu="avatarMenu" @watchAvatarMenu="watchAvatarMenu"></Avatar>
                    </span>
                    <span class="mr-6" v-if="token == null">
                        <router-link :to="'/connectwallet?redirectUrl=' + currentUrl">
                            <v-menu open-on-hover location="top">
                                <template v-slot:activator="{ props }">
                                    <v-icon v-bind="props" color="black01" icon="mdi mdi-wallet-outline" class="pointer" size="28"></v-icon>
                                </template>
                                <v-card class="pa-3 text-primaryGrey" rounded="0">Connect Wallet</v-card>
                            </v-menu>
                        </router-link>
                    </span>
                    <UntradingApp></UntradingApp>
                </v-row>
            </template>
        </v-app-bar>
        <!-- 【不显示】固定 Discord -->
        <a v-if="false" href="https://discord.gg/D5rZdhzVWh" target="_blank" class="del-underline" aria-label="Discord">
            <v-btn position="fixed" location="bottom right" class="mr-6 mb-12" icon variant="text" size="large" style="z-index: 999;">
                <v-menu v-model="fixedDiscordMenu" transition="slide-y-transition" :offset="10" location="top" open-on-hover contained>
                    <template v-slot:activator="{ props }" >
                        <div v-bind="props" >
                            <v-icon class="icon" color="secondary" size="32">icon-dis</v-icon>
                        </div>
                    </template>
                    <v-card class="pa-3 text-primaryGrey" rounded="0">
                        <h6 class="body-p font-weight-thin text-none">We are online! How may I help you today? </h6>
                    </v-card>
                </v-menu>
            </v-btn>
        </a>
        <!--【不显示】固定举报作弊图标 -->
        <v-btn v-if="false" position="fixed" location="bottom right" class="mr-6" icon variant="text" size="large" style="z-index: 999;" @click="reportCheatingDialog = true">
            <v-menu v-model="fixedReportCheatingMenu" transition="slide-y-transition" :offset="10" location="top" open-on-hover contained>
                <template v-slot:activator="{ props }" >
                    <div v-bind="props" >
                        <v-icon class="icon" color="text-icon" size="32">icon-alert</v-icon>
                    </div>
                </template>
                <v-card class="pa-3 text-primaryGrey" rounded="0">
                    <h6 class="body-p font-weight-thin text-none">Report Cheating</h6>
                </v-card>
            </v-menu>
        </v-btn>
        <!-- 举报作弊弹窗 -->
        <ReportCheating :show="reportCheatingDialog" @watchReportCheatingDialog="watchReportCheatingDialog"></ReportCheating>
        <!-- 消息条 -->
        <Snackbar></Snackbar>
    </div>
</template>
<script>
    import Logo from '@/components/common/Logo';
    import Theme from '@/components/common/Theme';
    import Notifications from '@/components/common/Notifications';
    import Installation from '@/components/common/Installation';
    import Avatar from '@/components/user/Avatar';
    import ReportCheating from '@/components/common/ReportCheating';
    import Snackbar from '@/components/common/Snackbar';
    import Search from '@/components/common/Search';
    import UntradingApp from '@/components/common/UntradingAppV2';
    import UnCryptosNavigationMobile from '@/components/common/navigation/v3/UnCryptosNavigationMobile';
    import UnNftsNavigationMobile from '@/components/common/navigation/v2/UnNFTsNavigationMobile';
    import UntradingNavigationMobile from '@/components/common/navigation/v2/UntradingNavigationMobile';
    import { mapGetters } from "vuex";
    import { mergeProps } from 'vue'
    export default {
        data(){
            return {
                // 显示搜索条
                showSearchBar: false,
                // 举报作弊弹窗
                reportCheatingDialog: false,
                currentUrl: window.location.href,
                // NFT 菜单
                nftMenus: [
                    { title: 'Explore', icon: 'mdi:mdi-compass', to: '/market' },
                    { title: 'Curated', icon: 'mdi:mdi-star', to: '/sets' },
                    { title: 'Collections', icon: 'mdi:mdi-image-filter-black-white', to: '/collections' }
                ],
                // 固定 Discord 菜单
                fixedDiscordMenu: false,
                // 固定举报作弊菜单
                fixedReportCheatingMenu: false,
                // 侧边导航栏菜单
                navigationDrawer: false,
                // 头像菜单
                avatarMenu: false,
                // 搜索图表路径
                searchIconPaths: ['/uncryptos'],
                // 搜索文本路径
                searchTextPaths: ['/uncryptos/search'],
                search: null,
            }
        },
        components: { Logo, Notifications, Installation, Avatar, ReportCheating, Theme, Snackbar, Search, UntradingApp, UnCryptosNavigationMobile, UnNftsNavigationMobile, UntradingNavigationMobile },
        created(){
    
        },
        mounted(){
    
        },
        computed: {
            ...mapGetters(['darkTheme', 'token', 'cryptoWrapPermission', 'cryptoProducts']),
            productMenus() {
                let menus = [
                    { title: 'unCryptos', iconType: 'icon', icon: null, linkType: 'to', link: '/uncryptos' },
                    { title: 'unNFTs', iconType: 'icon', icon: null, linkType: 'to', link: '/unnfts' },
                    { title: 'Testnet', iconType: 'icon', icon: null, linkType: 'a', link: 'https://testnet.untrading.org' },
                ];
                return menus;
            },
            docMenus() {
                let menus = [
                    { title: 'ERC-5173', iconType: 'icon', icon: null, linkType: 'a', link: 'https://eips.ethereum.org/EIPS/eip-5173' },
                    { title: 'Whitepaper', iconType: 'icon', icon: null, linkType: 'a', link: 'https://docs.untrading.org/whitepaper' },
                    { title: 'Tutorials', iconType: 'icon', icon: null, linkType: 'a', link: 'https://docs.untrading.org/tutorials' },
                ];
                return menus;
            },
            // 关于菜单
            aboutMenus() {
                let menus = [
                    { title: 'About', iconType: 'icon', icon: null, linkType: 'to', link: '/about' },
                    { title: 'Network DeFi', iconType: 'icon', icon: null, linkType: 'to', link: '/network-defi' },
                    { title: 'FAQs', iconType: 'icon', icon: null, linkType: 'a', link: 'https://docs.untrading.org/faqs' },
                    { title: 'Terms of Service', iconType: 'icon', icon: null, linkType: 'a', link: 'https://docs.untrading.org/terms-of-service' },
                    { title: 'Privacy Policy', iconType: 'icon', icon: null, linkType: 'a', link: 'https://docs.untrading.org/privacy-policy' },
                    { title: 'Legal', iconType: 'icon', icon: null, linkType: 'a', link: 'https://docs.untrading.org/risks' },
                    { title: '5173 Foundation', iconType: 'icon', icon: null, linkType: 'a', link: 'https://5173.foundation' },
                    { title: 'UN Token', iconType: 'icon', icon: null, linkType: 'to', link: '/un' },
                ];
                return menus;
            },
             // 开发者菜单
            developerMenus() {
                let menus = [
                    { title: 'Documentation', iconType: 'icon', icon: null, linkType: 'a', link: 'https://docs.untrading.org' },
                    { title: 'GitHub', iconType: 'icon', icon: null, linkType: 'a', link: 'https://github.com/untrading' },
                ];
                return menus;
            },
            // Crypto 菜单
            cryptoMenus() { 
                let menus = [
                    { title: 'Markets', iconType: 'icon', icon: 'mdi:mdi-trending-up', to: '/uncryptos' },
                ];
                this.cryptoProducts.forEach(product => {
                    let menu = {
                        title: product.currency,
                        iconType: 'image',
                        icon: product.icon,
                        to: `/uncryptos?product=${product.currency}`
                    }
                    menus.push(menu);
                });
                return menus;
            }
        },
        watch:{
            $route: {
                handler(n, o) {
                    this.currentUrl = window.location.href;
                },
                immediate: true
            },
        },
        methods: {
            // 监听举报作弊弹窗
            watchReportCheatingDialog(show) {
                this.reportCheatingDialog = show;
            },
            // 监听侧边栏
            watchNavigationDrawer(show) {
                this.navigationDrawer = show;
            },
            // 监听头像菜单
            watchAvatarMenu(show) {
                this.avatarMenu = show;
            },
            mergeProps
        }
    }
</script>
<style scoped></style>